import type { PretendDeathCommandData } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'
import { FormikDateInput, FormikForm } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

const validateKey = typeUtils.createValidator<PretendDeathCommandData>()

export const PretendDeathForm = (
  props: CommandDataFormProps<PretendDeathCommandData>,
) => {
  const translate = useTranslate()

  return (
    <FormikForm
      initialValues={
        {
          _type: 'PretendDeathCommandData',
        } satisfies PretendDeathCommandData
      }
      {...props}
    >
      <FormikDateInput
        label={translate('pretendDeathModalButton.deathDate')}
        name={validateKey('deathDate')}
      />
    </FormikForm>
  )
}
